module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-color-picker', {
    staticClass: "theme-picker",
    attrs: {
      "size": "small",
      "popper-class": "theme-picker-dropdown"
    },
    model: {
      value: (_vm.themeVal),
      callback: function($$v) {
        _vm.themeVal = $$v
      },
      expression: "themeVal"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-14aaa838","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/index/top/top-theme.vue
// module id = VmTc
// module chunks = 5